import React from "react";
import styles from "../../pages/renewal/Renew.module.css";

/**
 * Confirmation modal that displays all form details before submission.
 * Shows vehicle info, personal details, and insurance type.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is visible
 * @param {Function} props.onClose - Handler to close the modal
 * @param {Function} props.onConfirm - Handler for the submit/renew action
 * @param {Object} props.input - Current form data
 * @param {Object} props.renewData - Redux renewal data
 * @param {Array} props.vehicleModel - Available vehicle models
 * @param {Array} props.vehicleColor - Available vehicle colors
 * @param {Array} props.ceiMake - CEI makes list
 * @param {Array} props.niconMake - NICON makes list
 * @param {boolean} props.isLoading - Whether submission is in progress
 * @param {boolean} props.isSubmitting - Whether a submission ref is active
 */
const DetailsModal = ({
  isOpen,
  onClose,
  onConfirm,
  input,
  renewData,
  vehicleModel,
  vehicleColor,
  ceiMake,
  niconMake,
  isLoading,
  isSubmitting,
}) => {
  if (!isOpen) return null;

  const getMakeName = () =>
    ceiMake.find((make) => make.id === input.make)?.name ||
    niconMake.find((make) => make.id === input.make)?.name ||
    input.make;

  const getModelName = () => {
    if (renewData.insuranceType !== "NICON") {
      return vehicleModel.find(
        (model) => model.vehicleModelId === Number(input.model),
      )?.modelName;
    }
    return vehicleModel.find((model) => model.id === input.model)?.name;
  };

  const getColorName = () => {
    if (!vehicleColor) return input.color;
    const found = vehicleColor.find((color) =>
      renewData.insuranceType === "NICON"
        ? color.colorName === input.color
        : color.vehicleColorId === Number(input.color),
    );
    return found?.colorName || input.color;
  };

  const disabled = isLoading || isSubmitting;

  return (
    <div className={styles.modal_overlay} onClick={onClose}>
      <div className={styles.modal_card} onClick={(e) => e.stopPropagation()}>
        <h1 className={styles.modal_title}>Details</h1>
        <div
          className={styles.modal_description_container}
          style={{
            overflowY: "auto",
            maxHeight: "300px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <p className={styles.modal_description}>
            Full Name: {input.fullname}
          </p>
          <p className={styles.modal_description}>Phone: {input.phone}</p>
          <p className={styles.modal_description}>
            Chasis No: {input.chasisNo}
          </p>
          <p className={styles.modal_description}>
            Engine No: {input.engineNo}
          </p>
          <p className={styles.modal_description}>Year: {input.year}</p>
          <p className={styles.modal_description}>Make: {getMakeName()}</p>
          <p className={styles.modal_description}>Model: {getModelName()}</p>
          <p className={styles.modal_description}>Color: {getColorName()}</p>
          <p className={styles.modal_description}>Email: {input.email}</p>
          <p className={styles.modal_description}>
            Effective Date: {input.effectiveDate}
          </p>
          <p className={styles.modal_description}>
            Plate Number: {input.plate_no}
          </p>
          <p className={styles.modal_description}>
            Insurance Type: {renewData.insuranceType}
          </p>
          <p className={styles.modal_description}>
            Policy Type: {renewData.productsDetails.pin_type}
          </p>
        </div>

        <button
          type="button"
          disabled={disabled}
          onClick={onConfirm}
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
          }}
          className={styles.modal_button}
        >
          {isLoading ? "Loading..." : "Renew"}
        </button>
      </div>
    </div>
  );
};

export default DetailsModal;
